import { createFileRoute } from "@tanstack/react-router";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { FechamentoView } from "@/client/modules/financeiro/fechamento/fechamento-view";
import Loading from "@/client/modules/financeiro/fechamento/loading";

type Search = { year?: string; month?: string; regime?: string; area?: string };

export const Route = createFileRoute("/app/financeiro/fechamento")({
  validateSearch: (s: Record<string, unknown>): Search => ({
    year: s.year as string | undefined,
    month: s.month as string | undefined,
    regime: s.regime as string | undefined,
    area: s.area as string | undefined,
  }),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => ensurePage(context.queryClient, apiQuery("financeiro", "fechamentoPage", deps)),
  head: () => pageHead("Fechamento de caixa"),
  pendingComponent: Loading,
  component: FechamentoPage,
});

function FechamentoPage() {
  const search = Route.useSearch();
  const { data } = useApiSuspenseQuery("financeiro", "fechamentoPage", search);
  return <FechamentoView {...data} />;
}
